import { restApiClient } from '@/datasources';

interface FetchPDF {
  id: string;
}

export async function getAppointmentPDF({ id }: FetchPDF): Promise<Blob | null> {
  try {
    const { data: pdf } = await restApiClient.get<Blob>(`/online/customers/appointments/${id}/pdf/`, {
      responseType: 'blob',
    });
    return pdf;
  } catch {
    return null;
  }
}
